import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = { class: "shadow-sm" }

import { ref } from "vue";
import router from "@/router";
import { pb } from "@/pocketbase"
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import Heading from "@/components/Heading.vue";
import Error from "@/components/Error.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignInForm',
  setup(__props) {

const email = ref('');
const password = ref('');
const error = ref('');

async function login() {
  try {
    error.value = '';
    await pb.collection('users').authWithPassword(email.value, password.value);
    await router.push('/');
  } catch (e) {
    error.value = e.message;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Heading, null, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Sign In")
      ])),
      _: 1,
      __: [2]
    }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(login, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Input, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          id: "email",
          name: "email",
          label: "Email",
          placeholder: "you@example.com"
        }, null, 8, ["modelValue"]),
        _createVNode(Input, {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          type: "password",
          id: "password",
          name: "password",
          label: "Password",
          placeholder: "secret_password"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(Button, {
        label: "Sign In",
        icon: "lock"
      })
    ], 32),
    (error.value)
      ? (_openBlock(), _createBlock(Error, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})